import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

const STYLES = {
  pass: { icon: CheckCircle2, className: "bg-[#E4F1EB] text-[#0E6E52] border-[#0E6E52]/20" },
  warning: { icon: AlertTriangle, className: "bg-[#B7791A]/10 text-[#B7791A] border-[#B7791A]/20" },
  error: { icon: XCircle, className: "bg-[#B23A3A]/10 text-[#B23A3A] border-[#B23A3A]/20" },
};

export const ValidationFlag = ({ status, message, check }) => {
  const s = STYLES[status] || STYLES.pass;
  const Icon = s.icon;
  return (
    <div
      role="status"
      data-testid={`validation-flag-${(check || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`flex items-start gap-2.5 border rounded-md px-3 py-2.5 text-sm ${s.className}`}
    >
      <Icon className="w-4 h-4 mt-0.5 shrink-0" />
      <div>
        <p className="font-medium">{check}</p>
        <p className="text-xs opacity-90 mt-0.5">{message}</p>
      </div>
    </div>
  );
};
